export const API_KEYS = {
    GOOGLE_MAPS: "AIzaSyCV-lQjPW7OK8vHx8tXjEpuF64qcvZb4Kc",
}